import React, { useEffect, useState } from "react";
import { kontaktModel } from "../../../../api/models/kontaktModel";
import { useQueryWithPopupErrorHandling } from "../../../../providers/utils/hooks";
import { Kontakt } from "../../../../ts/Kontakt";
import {
  ILazyAutocompleteProps,
  LazyAutocomplete,
} from "../../../ui/LazyAutocomplete/LazyAutocomplete";

interface IProps extends Pick<ILazyAutocompleteProps<Kontakt>, "isDisabled"> {
  value: Kontakt | null;
  onChange: (value: Kontakt | null) => void;
}

export const KontaktLazyInput = ({
  value,
  onChange,
  ...props
}: IProps): React.ReactElement<IProps> => {
  const { call } = useQueryWithPopupErrorHandling();
  const [query, setQuery] = useState("");
  const [data, setData] = useState<Kontakt[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getKontakty = async () => {
      setIsLoading(true);
      await call(
        () =>
          kontaktModel.getFilteredKontakty({
            offset: 0,
            limit: 10,
            query: query ? JSON.stringify({ klient: query }) : undefined,
          }),
        "Zobrazení kontaktov nebolo úspešné",
        null,
        ({ data }) => {
          setData(data);
        },
        undefined,
        true
      );
      setIsLoading(false);
    };

    getKontakty();
  }, [query]);

  return (
    <LazyAutocomplete<Kontakt>
      value={value}
      onChange={onChange}
      data={[
        ...data,
        { _id: "info", nazev: "Zadajte hľadaný výraz pre zobrazenie výsledkov" } as Kontakt,
      ]}
      getOptionDisabled={(option) => option._id === "info"}
      getOptionKey={(option) => option._id}
      getOptionLabel={(option) => option.nazev}
      query={query}
      setQuery={setQuery}
      isLoading={isLoading}
      {...props}
    />
  );
};
